import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ICommonType } from '../shared/interfaces/common-type.interface';
import { AppCategoryId } from './category.model';
import {
  IGetFilesOrProfilesRequestViewModel,
  IGetFilesOrProfilesResponseViewModel,
  ITailNumberViewModel,
  IVehicleResponseModel,
  VehicleResponseDetailsModel,
} from './vehicle.model';
@Injectable({
  providedIn: 'root',
})
export class VehicleService {
  // todo: need to refactor to remove vehicleList$ and refreshVehicleList$
  public vehicleList$: BehaviorSubject<IVehicleResponseModel[]> = new BehaviorSubject<IVehicleResponseModel[]>([]);
  public refreshVehicleList$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private httpClient: HttpClient) {}

  createVehicle(vehicleDetail: any) {
    const url = `${environment.apiHost}/Vehicle`;

    return this.httpClient.post(url, vehicleDetail).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getVehicleDetail(
    vendorId: string,
    isShowAll: boolean,
    category: string,
    limit?: number,
    offset?: number,
    searchString?: string,
  ): Observable<VehicleResponseDetailsModel> {
    const url = `${environment.apiHost}/Vehicle/${vendorId}/${isShowAll}/${category}/${offset}/${limit}/${searchString}`;

    return this.httpClient.get<VehicleResponseDetailsModel>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getFilesOrProfileDownload(requestBody: IGetFilesOrProfilesRequestViewModel): Observable<IGetFilesOrProfilesResponseViewModel[]> {
    const url = `${environment.apiHost}/Vehicle/FilesOrProfileDownload`;

    return this.httpClient
      .post<IGetFilesOrProfilesResponseViewModel[]>(url, requestBody)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  deleteVehicleDelete(vehicle: string) {
    const url = `${environment.apiHost}/Vehicle/${vehicle}`;

    return this.httpClient.delete(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  toggleVehicleDetail(isEnable: boolean, vendorId: string) {
    const url = `${environment.apiHost}/Vehicle/enableVehicle/${isEnable}/${vendorId}`;

    return this.httpClient.get(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  updateVehicleDetail(vehicleDetail: any, vendorId: string) {
    const url = `${environment.apiHost}/Vehicle/${vendorId}`;

    return this.httpClient.put(url, vehicleDetail).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getLocation(vendorId: string) {
    const url = `${environment.apiHost}/Vehicle/GetLocation/${vendorId}`;

    return this.httpClient.get(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getAirCategory() {
    const url = `${environment.apiHost}/AppCategory/AircraftCategory`;

    return this.httpClient.get(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getVehicleCategory() {
    const url = `${environment.apiHost}/AppCategory/VehicleCategory`;

    return this.httpClient.get(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getTailNumberList(): Observable<ITailNumberViewModel[]> {
    const url = `${environment.apiHost}/Vehicle/GetTailNumberList`;

    return this.httpClient.get<ITailNumberViewModel[]>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  async patchVehicleData(
    requestData: {
      businessUnitId: string;
      entityTableName: string;
      entityTableValue: any;
      vehicleType: string;
      isFetchFiles: boolean;
      isFetchProfile: boolean;
    },
    detailArray: IVehicleResponseModel[],
  ): Promise<IVehicleResponseModel[]> {
    // todo later should be refactored to use the Observable approach
    return new Promise<IVehicleResponseModel[]>((resolve) => {
      this.getFilesOrProfileDownload(requestData).subscribe(
        (res) => {
          res.forEach((item) => {
            const vehicleDetail = detailArray.find((details) => details.vehicleId === item.entityTableValue);

            if (vehicleDetail !== undefined) {
              vehicleDetail.profilePicture = item.profilePicture;
              vehicleDetail.insuranceFile = item.insuranceFile;
              vehicleDetail.registrationFile = item.registrationFile;
            }
          });
          resolve(detailArray);
        },
        () => {
          resolve(detailArray);
        },
      );
    });
  }

  getAllAircraftList(): Observable<ICommonType[]> {
    const url = `${environment.apiHost}/Vehicle/GetAircraftTypeList`;
    return this.httpClient.get<ICommonType[]>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getAircraftCategoryList(): Observable<AppCategoryId[]> {
    const url = `${environment.apiHost}/AppCategory/AircraftCategory`;
    return this.httpClient.get<AppCategoryId[]>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
